import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './modules/auth/_services/auth.guard';

export const routes: Routes = [
    {
        path: 'courses/:course/:level/:subject',
        loadChildren: () =>
            import('./pages/website/subject/subject.module').then(
                (m) => m.SubjectModule
            ),
    },
    {
        path: 'courses/:course/:level/:subject/:studymethod',
        loadChildren: () =>
            import('./pages/website/subject/subject.module').then(
                (m) => m.SubjectModule
            ),
    },

    {
        path: 'courses/:slug',
        loadChildren: () =>
            import('./pages/website/institute/institute.module').then(
                (m) => m.InstituteModule
            ),
    },
    {
        path: 'courses/:course/:level',
        loadChildren: () =>
            import('./pages/website/subject-catalogue/subject-catalogue.module').then(
                (m) => m.SubjectCatalogueModule
            ),
    },
    {
        path: 'study-methods/:slug',
        loadChildren: () =>
            import('./pages/website/study-method-detail/study-method-detail.module').then(
                (m) => m.StudyMethodDetailModule
            ),
    },
    {
        path: 'notice-board',
        loadChildren: () =>
            import('./pages/website/notice-board/notice-board.module').then(
                (m) => m.NoticeBoardModule
            ),
    },
    {
        path: 'notice-board/draft/:slug',
        loadChildren: () =>
            import('./pages/website/notice-board/post/post.module').then((m) => m.PostModule),
    },
    {
        path: 'notice-board/post/:slug',
        loadChildren: () =>
            import('./pages/website/notice-board/post/post.module').then((m) => m.PostModule),
    },
    {
        path: 'my-account',
        loadChildren: () =>
            import('./pages/website/my-account/my-account.module').then(
                (m) => m.MyAccountModule
            ),
    },
    {
        path: 'cart/login',
        loadChildren: () =>
            import('./pages/website/cart-login/cart-login.module').then(
                (m) => m.CartLoginModule
            ),
    },
    {
        path: 'cart/register',
        loadChildren: () =>
            import('./pages/website/cart-register/cart-register.module').then(
                (m) => m.CartRegisterModule
            ),
    },
    {
        path: 'cart',
        loadChildren: () =>
            import('./pages/website/cart/cart.module').then(
                (m) => m.CartModule
            ),
    },
    {
        path: 'cart/delivery',
        loadChildren: () =>
            import('./pages/website/cart-delivery/cart-delivery.module').then(
                (m) => m.CartDeliveryModule
            ),
    },
    {
        path: 'cart/billing',
        loadChildren: () =>
            import('./pages/website/cart-billing/cart-billing.module').then(
                (m) => m.CartBillingModule
            ),
    },
    {
        path: 'cart/payment',
        loadChildren: () =>
            import('./pages/website/cart-payment/cart-payment.module').then(
                (m) => m.CartPaymentModule
            ),
    },
    {
        path: 'cart/thanks',
        loadChildren: () =>
            import('./pages/website/cart-thanks/cart-thanks.module').then(
                (m) => m.CartThanksModule
            ),
    },
    {
        path: 'cart/thanks-eft',
        loadChildren: () =>
            import('./pages/website/cart-thanks/cart-thanks.module').then(
                (m) => m.CartThanksModule
            ),
    },
    {
        path: 'cart/thanks-cc',
        loadChildren: () =>
            import('./pages/website/cart-thanks/cart-thanks.module').then(
                (m) => m.CartThanksModule
            ),
    },
    {
        path: 'cart/cc-failure',
        loadChildren: () =>
            import('./pages/website/cart-thanks/cart-thanks.module').then(
                (m) => m.CartThanksModule
            ),
    },
    {
        path: 'forgot-password',
        loadChildren: () =>
            import('./pages/website/forgot-password/forgot-password.module').then(
                (m) => m.ForgotPasswordModule
            ),
    },
    {
        path: 'password/reset/:token',
        loadChildren: () =>
            import('./pages/website/reset-password/reset-password.module').then(
                (m) => m.ResetPasswordModule
            ),
    },
    {
        path: 'password/firsttimelogin/:token',
        loadChildren: () =>
            import('./pages/website/cart-login/cart-login.module').then(
                (m) => m.CartLoginModule
            ),
    },
    {
        path: 'timetable',
        loadChildren: () =>
            import('./pages/website/timetable/timetable.module').then(
                (m) => m.TimetableModule
            ),
    },
    {
        path: 'timetable/:id',
        loadChildren: () =>
            import('./pages/website/timetable/timetable.module').then(
                (m) => m.TimetableModule
            ),
    },
    {
        path: 'mobile-menu',
        loadChildren: () =>
            import('./pages/website/mobile-menu/mobile-menu.module').then(
                (m) => m.MobileMenuModule
            ),
    },
    {
        path: 'page-builder/draft/:slug',
        loadChildren: () =>
            import('./pages/website/page-builder/page-builder.module').then(
                (m) => m.PageBuilderModule
            ),
    },
    {
        path: 'error',
        loadChildren: () =>
            import('./modules/errors/errors.module').then(
                (m) => m.ErrorsModule
            ),
    },
    // { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
        path: 'home',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '',
        loadChildren: () =>
            import('./pages/website/page-builder/page-builder.module').then(
                (m) => m.PageBuilderModule
            ),
    },
    {
        path: ':slug/:child_slug',
        loadChildren: () =>
            import('./pages/website/page-builder/page-builder.module').then(
                (m) => m.PageBuilderModule
            ),
    },
    {
        path: ':slug',
        loadChildren: () =>
            import('./pages/website/page-builder/page-builder.module').then(
                (m) => m.PageBuilderModule
            ),
    },
    {
        path: '**',
        loadChildren: () =>
            import('./pages/website/page-builder/page-builder.module').then(
                (m) => m.PageBuilderModule
            ),
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        onSameUrlNavigation: 'ignore',
        initialNavigation: 'enabled',
        scrollPositionRestoration: 'enabled'
        // enableTracing: true
    })], // onSameURlNavigation used for reloading the same base page just with different params
    exports: [RouterModule],
})
export class AppRoutingModule { }
